const { REACT_APP_BASE_URL } = process.env;
const apiURL = REACT_APP_BASE_URL || "http://localhost:4000";
export const BASE_URL = apiURL;
 